import { useEffect, useState } from "react";
import { FaRegArrowAltCircleUp } from "react-icons/fa";
import { IoArrowUpSharp } from "react-icons/io5";

const ScrollToTopButton = () => {
    const [isVisible, setVisible] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 200) {
                setVisible(true);
            } else {
                setVisible(false);
            }
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

    return (
        <div className="z-50">
            {isVisible && (
                <button
                    className="fixed bottom-5 right-5 inline-flex flex-col justify-between h-14 w-14 rounded-full items-center px-2 py-2 text-sm  hover:bg-gray-400 hover:text-white  text-slate-700"
                    onClick={scrollToTop}
                >
                    <div className="self-start w-full flex justify-center items-center">
                        <IoArrowUpSharp className="-ml-0.5 h-10 w-10" aria-hidden="true" />
                    </div>
                    {/* <span className="self-end w-full flex justify-center items-center text-center">Top</span> */}
                </button>
            )}
        </div>
    );
};

export default ScrollToTopButton;
